import {
    HttpInterceptorFn
} from '@angular/common/http';

import {
    inject
} from '@angular/core';

import {
    SessionService
} from '../services/session.service';

import {
    environment
} from '../../../../environments/environment';


export const authInterceptor: HttpInterceptorFn =
    (request, next) => {

        const session =
            inject(
                SessionService
            );


        const token =
            session.getAccessToken();


        /*
         * =========================================================
         * IDENTIFY OUR APIS
         * =========================================================
         */

        const isIdentityApi =
            request.url.startsWith(
                environment.identityApiUrl
            );


        const isRestaurantApi =
            request.url.startsWith(
                environment.restaurantApiUrl
            );


        const isMenuApi =
            request.url.startsWith(
                environment.menuApiUrl
            );


        /*
         * Nunca enviamos nuestro JWT
         * a servicios externos.
         */
        if (
            !isIdentityApi
            &&
            !isRestaurantApi
            &&
            !isMenuApi
        ) {

            return next(
                request
            );
        }


        /*
         * =========================================================
         * PUBLIC ENDPOINTS
         * =========================================================
         */

        /*
         * Login.
         *
         * POST
         * /api/v1/auth/login
         */
        const isLoginRequest =
            isIdentityApi
            &&
            request.url.includes(
                '/api/v1/auth/login'
            );


        /*
         * RESTAURANT SERVICE PUBLIC
         *
         * Ejemplo:
         *
         * POST
         * /api/v1/public/table-access/resolve
         *
         * El cliente que escanea el QR
         * todavía no necesita iniciar sesión.
         */
        const isPublicRestaurantRequest =
            isRestaurantApi
            &&
            request.url.includes(
                '/api/v1/public/'
            );


        /*
         * MENU SERVICE PUBLIC
         *
         * Ejemplo:
         *
         * GET
         * /api/v1/public/restaurants/{restaurantId}
         * /branches/{branchId}/catalog
         *
         * Este endpoint será usado desde /order.
         */
        const isPublicMenuRequest =
            isMenuApi
            &&
            request.url.includes(
                '/api/v1/public/'
            );


        if (
            isLoginRequest
            ||
            isPublicRestaurantRequest
            ||
            isPublicMenuRequest
        ) {

            return next(
                request
            );
        }


        /*
         * =========================================================
         * NO SESSION
         * =========================================================
         */

        if (
            !token
        ) {

            return next(
                request
            );
        }


        /*
         * =========================================================
         * AUTHENTICATED REQUEST
         * =========================================================
         */

        const authenticatedRequest =
            request.clone({

                setHeaders: {

                    Authorization:
                        `Bearer ${token}`

                }

            });


        return next(
            authenticatedRequest
        );
    };